/**
 * Calculate baseball pitching statistics
 * @param {Object} params
 * @param {number} params.inningsPitched - Total innings pitched (can be decimal like 4.66 for 4 2/3, but logic should handle it)
 * @param {number} params.strikeouts - Total strikeouts
 * @param {number} params.walks - Total walks
 * @param {number} params.hits - Total hits allowed
 * @param {number} params.runsAllowed - Total runs allowed
 * @param {number} params.pitches - Total pitches thrown
 * @returns {Object} Calculated statistics { k9, bb9, kbb, whip, pip, ra }
 */
export const calculateStats = ({
  inningsPitched,
  strikeouts,
  walks,
  hits,
  runsAllowed,
  pitches
}) => {
  // Prevent division by zero
  if (!inningsPitched || inningsPitched <= 0) {
    return {
      k9: '0.00',
      bb9: '0.00',
      kbb: '0.00',
      whip: '0.00',
      pip: '0.0',
      ra: '0.00'
    };
  }

  // K/9 = (K * 9) / IP
  const k9 = ((strikeouts * 9) / inningsPitched).toFixed(2);

  // BB/9 = (BB * 9) / IP
  const bb9 = ((walks * 9) / inningsPitched).toFixed(2);

  // K/BB = K / BB (Avoid division by zero)
  const kbb = walks > 0 ? (strikeouts / walks).toFixed(2) : 'Inf';

  // WHIP = (Walks + Hits) / IP
  const whip = ((walks + hits) / inningsPitched).toFixed(2);

  // P/IP = Pitches / IP
  const pip = (pitches / inningsPitched).toFixed(1);

  // RA (Run Average) = (Runs * 9) / IP
  const ra = ((runsAllowed * 9) / inningsPitched).toFixed(2);

  return {
    k9,
    bb9,
    kbb,
    whip,
    pip,
    ra
  };
};

